import { render, staticRenderFns } from "./NewCollaboration.vue?vue&type=template&id=c3b9a540&scoped=true"
import script from "./NewCollaboration.vue?vue&type=script&lang=js"
export * from "./NewCollaboration.vue?vue&type=script&lang=js"
import style0 from "./NewCollaboration.vue?vue&type=style&index=0&id=c3b9a540&prod&scoped=true&lang=css"
import style1 from "./NewCollaboration.vue?vue&type=style&index=1&id=c3b9a540&prod&lang=css"
import style2 from "./NewCollaboration.vue?vue&type=style&index=2&id=c3b9a540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b9a540",
  null
  
)

export default component.exports